/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RecentlyViewedItem } from './base';

/**
 * Represents base functionality of a recently viewed manager which operates a list of items for recently viewed.
 */
export class RecentlyViewedManager<ItemId, Item extends RecentlyViewedItem<ItemId> = RecentlyViewedItem<ItemId>> {
    private _recentlyViewedItems: Item[];

    public get items(): Item[] {
        return this._recentlyViewedItems;
    }

    public constructor(...items: Item[]) {
        this._recentlyViewedItems = items;
    }
}
